import React from 'react';

class Level extends React.Component {
    componentDidMount() {
        let linearGrad = 'linear-gradient('
            + this.props.colorTop + ' 0%, ' +
            this.props.colorTop + ' ' + (100 - this.props.level).toString() + '%, ' +
            this.props.colorBottom + ' ' + (100 - this.props.level).toString() + '%, ' +
            this.props.colorBottom + ' 100%)';
        document.getElementById(this.props.name + '-image').style.backgroundImage = linearGrad;
    }
    render() {
        return (
            <div
                className="contenedor-nivel"
                style={{ width: this.props.width + 'px', height: this.props.height + 'px' }}
                id={this.props.name + '-image'}
            >
                <img src={`https://s3-us-west-1.amazonaws.com/siscoa/recursos/inform-icons/${this.props.image}`}
                    alt={this.props.name}
                    height={(this.props.height + 3) + 'px'}
                    width={(this.props.width + 2) + 'px'}
                    style={{ marginTop: '-2px', marginLeft: '-1px' }}
                />
            </div>
        );
    }
}

export default Level;